import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/u6zDUVxbU8ZNn4SCtpUZBf/heylloyd-image-1771266281150.png';
export function HeroSection() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-16 px-4 md:pt-20 md:pb-24 overflow-hidden bg-[#FDFBF7]" data-id="element-83">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-84">
        <div className="absolute top-[-10%] right-[-5%] w-64 h-64 rounded-full bg-[#C05621] blur-3xl" data-id="element-85"></div>
        <div className="absolute bottom-[10%] left-[-5%] w-80 h-80 rounded-full bg-[#2F855A] blur-3xl" data-id="element-86"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-88">
          <span className="inline-block py-1 px-3 rounded-full bg-orange-100 text-[#C05621] text-sm font-bold tracking-wide mb-6 border border-orange-200" data-id="element-89">
            PARA PREDIABETES Y TIPO 2
          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6 tracking-tight" data-id="element-90">
            No dejes la tortilla. <br data-id="element-91" />
            <span className="text-[#C05621]" data-id="element-92">Deja los picos.</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-93">
            El plan de 30 días para comer normal y vivir más tranquilo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.7
      }} className="flex justify-center mb-14" data-id="element-94">
          <div className="relative" data-id="element-95">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#2F855A]/20 via-transparent to-[#C05621]/20 rounded-3xl blur-2xl" data-id="element-96"></div>
            <img src={PRODUCT_IMAGE} alt="El Plato Mexicano Antipicos - Portada del ebook" className="relative w-64 md:w-80 rounded-2xl shadow-2xl" data-id="element-97" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl p-6 md:p-10 border border-gray-100" data-id="element-98">
          <div className="prose prose-lg max-w-none text-gray-700" data-id="element-99">
            <p className="font-medium text-lg mb-4" data-id="element-100">
              Si vives con prediabetes o diabetes tipo 2 en México, seguro ya
              conoces esa sensación:
            </p>

            <p className="mb-4" data-id="element-101">
              Comes "normal"… y luego te llega el bajón, el sueño pesado, la
              culpa, el miedo.
            </p>

            <p className="mb-4 font-bold text-gray-900" data-id="element-102">
              Y lo peor no es el antojo. Lo peor es no tener un plan.
            </p>

            <p className="mb-6" data-id="element-103">
              Porque en la vida real no existe "comida perfecta". Existe: fonda,
              tacos, guiso, pan en la mañana, visita con familia, estrés,
              cansancio.
            </p>

            <div className="bg-orange-50 p-6 rounded-xl border-l-4 border-[#C05621] mb-8" data-id="element-104">
              <p className="font-bold text-gray-900 mb-2" data-id="element-105">
                Por eso la mayoría fracasa con lo típico:
              </p>
              <ul className="list-disc pl-5 space-y-1 mb-0 text-gray-800" data-id="element-106">
                <li data-id="element-107">"No comas tortilla."</li>
                <li data-id="element-108">"Pésalo todo."</li>
                <li data-id="element-109">"Cuenta carbohidratos."</li>
                <li data-id="element-110">"Haz dieta."</li>
              </ul>
            </div>

            <p className="mb-8 text-lg" data-id="element-111">
              No es que sea imposible… es que es{' '}
              <span className="font-bold text-[#C05621]" data-id="element-112">inhumano</span>{' '}
              sostenerlo cuando tienes vida.
            </p>

            <p className="text-lg leading-relaxed" data-id="element-113">
              <strong data-id="element-114">El Plato Mexicano Antipicos (30 días)</strong> es un PDF
              práctico para que vuelvas a sentir control con comida mexicana
              real, usando un sistema de 3 palancas que puedes aplicar hoy,
              aunque tengas prisa, aunque comas fuera, aunque no quieras vivir a
              dieta.
            </p>
          </div>

          <div className="mt-10 text-center" data-id="element-115">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-[#2F855A] rounded-full hover:bg-[#276749] transition-all transform hover:scale-105 shadow-lg hover:shadow-xl group" data-id="element-116">
              Quiero el plan
              <ArrowDown className="ml-2 w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-117" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}